import { GET } from "../API"

let source;

export const getMessageForConversationApi = (conversationId, page, onSuccess, onError) => {
    source = GET(`/api/v1/chat/conversations/${conversationId}/messages?page=${page}`, onSuccess, onError, true, source)
}